import { useSettings } from "@/context/SettingsContext";
import { Lock } from "lucide-react";

export default function Privacy() {
  const { settings } = useSettings();
  const holder = settings?.copyright_holder || settings?.site_name || "Drops of Honey";

  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-12">
      <div className="flex items-center gap-2 mb-2"><Lock className="w-6 h-6 brand-text" /><p className="font-tech text-xs uppercase tracking-widest brand-text">Privacy</p></div>
      <h1 className="font-display text-4xl font-bold mb-6">Privacy Policy</h1>

      <div className="surface border rounded-2xl p-6 space-y-5 leading-relaxed">
        <section>
          <h2 className="font-display text-2xl font-bold mb-1">We do not share your data</h2>
          <p><strong>{holder}</strong> does not sell, rent, or share your personal data with any third parties. The information you provide — your account details, collection, wishlist, messages, and trades — stays within this platform and is used only to operate the service for you.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-bold mb-1">What we store</h2>
          <p>We store your email and a securely hashed password (never in plain text), your profile, and the collection, forum, message and trade data you create. Passwords are protected with industry-standard hashing and are never visible to anyone, including administrators.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-bold mb-1">What other collectors can see</h2>
          <p>Your public profile shows only your username, optional display name, location, bio, avatar, wishlist and collection count. Your email address, password, purchase prices and private messages are never shown to other users.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-bold mb-1">Email</h2>
          <p>We send transactional emails (e.g., new-message and ad-approval notices) only to you, about your own account activity. We never send your address to advertisers or add you to marketing lists.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-bold mb-1">Your control</h2>
          <p>You may edit your profile at any time and request removal of your account and its data by contacting {holder}.</p>
        </section>
      </div>
    </div>
  );
}
